import { Form, Input, Select, Typography, notification } from "antd";
import axios from "axios";
import * as process from "process";
import React, { useEffect, useState } from "react";
import { isoCodeToCountry } from "../services/countries/countryNames";

const { Option } = Select;

export const isoToCountryFlag = (isoCode: string) => {
  const offset = 127397;
  return Array.from(isoCode)
    .map((char) => String.fromCodePoint(char.charCodeAt(0) + offset))
    .join("");
};

interface PhoneProps {
  form: any;
  formProps: any;
}

const EditPhoneForm: React.FC<PhoneProps> = ({ form, formProps }) => {
  const [phonePrefixes, setPhonePrefixes] = useState<
    {
      phone: string;
      isoCode: string;
      phonePrefix: string;
    }[]
  >([]);

  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchPhonePrefixes = async () => {
      try {
        const response = await axios.get(`${apiUrl}/phone-prefixes`);
        setPhonePrefixes(response.data);
      } catch (error) {
        notification.error({
          message: "Error",
          description: "An error occurred while fetching phone prefixes.",
        });
      }
    };

    fetchPhonePrefixes();
  }, []);

  const [selectedPrefix, setSelectedPrefix] = useState<string>("");
  const [selectedCountry, setSelectedCountry] = useState<string>("");
  const [phoneInput, setPhoneInput] = useState<string>("");

  useEffect(() => {
    if (selectedPrefix || selectedCountry || phoneInput) {
      form.setFieldsValue({
        phone: `+${selectedPrefix}${phoneInput}`,
        isoCode: selectedCountry,
      });
    }
  }, [phoneInput, selectedPrefix, selectedCountry]);

  const handleIsoCodeChange = (value: string) => {
    let prefix = value.split(" ")[0].slice(1);
    prefix = prefix.replace(/[-\s]/g, "");
    setSelectedPrefix(prefix);
    setSelectedCountry(value.split(" ")[1]);
  };

  const { Text } = Typography;
  return (
    <>
      <Form.Item name="phone" label="Phone">
        <div>
          <Text style={{ fontSize: "12px" }}>
            Current value: {formProps?.initialValues?.phone}
          </Text>
        </div>
        <Input.Group compact>
          <Select
            style={{ width: "15%" }}
            virtual={false}
            showSearch
            value={`+${selectedPrefix} ${isoToCountryFlag(selectedCountry)}`}
            onChange={(value: string) => {
              handleIsoCodeChange(value);
            }}
          >
            {phonePrefixes.map((country) => (
              <Option
                value={`+${country.phonePrefix} ${country.isoCode} ${
                  isoCodeToCountry[country.isoCode]
                }`}
                key={`+${country.phonePrefix} ${country.isoCode}`}
              >
                {`+${country.phonePrefix} ${isoToCountryFlag(
                  country.isoCode
                )} ${isoCodeToCountry[country.isoCode]}`}
              </Option>
            ))}
          </Select>
          <Input
            style={{ width: "35%" }}
            value={phoneInput}
            onChange={(e) => {
              setPhoneInput(e.target.value);
            }}
          />
        </Input.Group>
      </Form.Item>
      <Form.Item name="isoCode" style={{ display: "none" }}>
        <Input />
      </Form.Item>
    </>
  );
};

export default EditPhoneForm;
